"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakerFactory = void 0;
var FakerFactory = (function () {
    function FakerFactory(factory) {
        this.factory = factory;
    }
    FakerFactory.prototype.new = function (override) {
        if (!override) {
            return this.factory();
        }
        return __assign(__assign({}, this.factory()), override);
    };
    FakerFactory.prototype.array = function (total, override) {
        var arr = [];
        for (var i = 0; i < total; i++) {
            if (typeof override === 'function') {
                arr.push(this.new(override(i)));
            }
            else {
                arr.push(this.new(override));
            }
        }
        return arr;
    };
    FakerFactory.prototype.fixture = function (id, override) {
        if (!this._fixture) {
            this._fixture = new Map();
        }
        if (!this._fixture.get(id)) {
            this._fixture.set(id, this.new(override));
        }
        if (!override) {
            return this._fixture.get(id);
        }
        return __assign(__assign({}, this._fixture.get(id)), override);
    };
    return FakerFactory;
}());
exports.FakerFactory = FakerFactory;
//# sourceMappingURL=FakerFactory.js.map